export interface PurchaseOrderFromPreviousIds {
  id: string;
}
